const formatMoney = (value: number | string, options?: Intl.NumberFormatOptions) => {
    const formatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        ...options,
    });

    return formatter.format(Number(value));
};

const formatMoneyShort = (value: number | string) => {
    const amount = Number(value);

    if (amount >= 1000) {
        return `€ ${Math.floor(amount / 1000)}k`;
    }

    return `€ ${amount}`;
};

export {
    formatMoney,
    formatMoneyShort,
};
